import React from "react";
import MiniCartContent from "theme/modules/Cart/MiniCart/MiniCartContent";

const CartNavigation = ({ toggleMiniCart }) => {
  return <MiniCartContent toggleMiniCart={toggleMiniCart} />;
};

export default CartNavigation;
